import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const raw = window.atob((base64String + padding).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && typeof Notification !== 'undefined';

export async function isPushSubscribed() {
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker.getRegistration();
  return !!(reg && await reg.pushManager.getSubscription());
}

// Asks permission, subscribes this device and registers it with the backend (shared by Farmor Corgi + Hampus).
export async function subscribePush() {
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notiser blockerade');
  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  const { data: vk } = await axios.get(`${API}/farmor-corgi/notifications/vapid-key`, { withCredentials: true });
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(vk.publicKey) });
  const subJson = sub.toJSON();
  await axios.post(`${API}/farmor-corgi/notifications/subscribe`, { endpoint: subJson.endpoint, keys: subJson.keys }, { withCredentials: true });
  return perm;
}
